import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FloatingActionsComponent } from './floating-actions.component';
import { FeedbackModule } from '../feedback';
import { ScrollTopModule } from '../scroll-top';
import { FloatingPanelModule } from '../floating-panel';

@NgModule({
  declarations: [FloatingActionsComponent],
  imports: [CommonModule, FeedbackModule, ScrollTopModule, FloatingPanelModule],
  exports: [FloatingActionsComponent],
})
export class FloatingActionsModule {}
